// Local
/*export const environment = {
  production: false,
  DEV_API_URL: 'undefined',
  STAGE: 'mcattaneo',
  API_BASE_PATH: 'https://v2-admins-api.mcattaneo.splittypay.com',
  IDENTITY_POOL_ID: 'eu-central-1:c7dc5d42-e58a-4eed-bbfb-c969de33904b',
  IDENTITY_POOL_REGION: 'eu-central-1',
  USER_POOL_ID: 'eu-central-1_zmgEktH6x',
  USER_POOL_WEB_CLIENT_ID: 'l6n94eaur0dnl0jdgrvvrtmgo',
  USER_POOL_REGION: 'eu-central-1',
  BUCKET_NAME: 'mcattaneo-splittypay-buyer',
  BUCKET_REGION: 'eu-central-1',
  STORE_BUCKET_REGION: 'eu-central-1',
  STORE_BUCKET_NAME: 'mcattaneo-splittypay-store',
  STRIPE_PUBLIC_KEY: 'undefined',
};*/

// Dev
export const environment = {
  production: false,
  DEV_API_URL: 'undefined',
  STAGE: 'dev',
  API_BASE_PATH: 'https://v2-admins-api.dev.splittypay.com',
  IDENTITY_POOL_ID: 'eu-central-1:de4280bd-fc63-4a1b-b214-3d8aab67b1ca',
  IDENTITY_POOL_REGION: 'eu-central-1',
  USER_POOL_ID: 'eu-central-1_f5TNFAMJg',
  USER_POOL_WEB_CLIENT_ID: '6hhr5vd4ccb4o76ot5rhjoe6va',
  USER_POOL_REGION: 'eu-central-1',
  BUCKET_NAME: 'dev-splittypay-buyer',
  BUCKET_REGION: 'eu-central-1',
  STORE_BUCKET_REGION: 'eu-central-1',
  STORE_BUCKET_NAME: 'dev-splittypay-store',
  STRIPE_PUBLIC_KEY: 'undefined',
};

// Coll
/*
export const environment = {
  production: false,
  DEV_API_URL: 'undefined',
  STAGE: 'coll',
  API_BASE_PATH: 'https://v2-admins-api.coll.splittypay.com',
  IDENTITY_POOL_ID: 'eu-central-1:d3adfe0d-d88d-47a9-937b-3deb3a17773f',
  IDENTITY_POOL_REGION: 'eu-central-1',
  USER_POOL_ID: 'eu-central-1_bUTv6OwoV',
  USER_POOL_WEB_CLIENT_ID: '5dnag6hefjkq1a2042eo7kia69',
  USER_POOL_REGION: 'eu-central-1',
  BUCKET_NAME: 'coll-splittypay-buyer',
  BUCKET_REGION: 'eu-central-1',
  STORE_BUCKET_REGION: 'eu-central-1',
  STORE_BUCKET_NAME: 'coll-splittypay-store',
  STRIPE_PUBLIC_KEY: 'undefined',
};
*/
